<template>
  <div v-if="!name">
    <h5 class="mb-8">Action that triggers this automation</h5>
    <ul class="flex flex-col">
      <li v-for="(value, key) in triggers" :key="key" class="mt-2">
        <button class="btn btn-success w-full" @click="$emit('update-name', value.name)">
          {{ value.displayName }}
        </button>
      </li>
    </ul>
  </div>
  <div v-else>
    <h6 class="font-normal text-base mb-8">
      When <span class="font-medium">{{ trigger.displayName }}</span>
    </h6>
    <component
      :is="component"
      :default-data="props || {}"
      :project-uuid="projectUuid"
      @update-props="$emit('update-props', $event)"
    />
  </div>
</template>

<script>
import { upperFirst, camelCase } from 'lodash-es';

const CONTACT_REQUEST_SUBMIT_FORM = 'contact_request.submit.form';

const TRIGGERS = {
  [CONTACT_REQUEST_SUBMIT_FORM]: {
    name: CONTACT_REQUEST_SUBMIT_FORM,
    displayName: 'Contact request submits a form',
  },
};

export default {
  props: {
    projectUuid: { type: String, required: true },
    name: { type: String, default: null },
    props: { type: Object, default: null },
  },

  data() {
    return {
      triggers: { ...TRIGGERS },
    };
  },

  computed: {
    trigger() {
      if (!this.name) return null;

      return TRIGGERS[this.name] || null;
    },
    component() {
      if (!this.trigger) return null;

      const componentName = upperFirst(camelCase(this.trigger.name));

      return () => import(`./Actions/${componentName}.vue`);
    },
  },
};
</script>
